import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "section-text" }, "Representantes legales suplentes", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, null, {
    default: _withCtx(() => [
      _createVNode(_component_el_row, { gutter: 24 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, { gutter: 24 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 22 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table, {
                height: "200",
                data: _ctx.objetoInfoRepresentanteSuplente.RLSuplente,
                span: 24
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, { width: "20%" }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("span", null, [
                        _createElementVNode("b", null, _toDisplayString(scope.$index + 1), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    class: "section-text-color",
                    label: "Nombre de representantes legales suplentes",
                    width: "228px;"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_input, {
                        type: "text",
                        modelValue: scope.row.NombreRLSuplente,
                        "onUpdate:modelValue": ($event: any) => ((scope.row.NombreRLSuplente) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "Tipo ID",
                    width: "140px;"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_select, {
                        modelValue: scope.row.TipoIdRLSuplente,
                        "onUpdate:modelValue": ($event: any) => ((scope.row.TipoIdRLSuplente) = $event),
                        placeholder: "Seleccionar"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parametricas.tipoDeIdentificacion, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.codigo,
                              label: item.valor,
                              value: item.valor
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "N° ID",
                    width: "150px;"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_input, {
                        type: "text",
                        modelValue: scope.row.NumeroIdentificacionRLSuplente,
                        "onUpdate:modelValue": ($event: any) => ((scope.row.NumeroIdentificacionRLSuplente) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "Cargo en la empresa",
                    width: "200px;"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_input, {
                        type: "text",
                        modelValue: scope.row.CargoEmpresaRLSuplente,
                        "onUpdate:modelValue": ($event: any) => ((scope.row.CargoEmpresaRLSuplente) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "Correo electrónico (e-mail)",
                    width: "250px;"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_input, {
                        type: "text",
                        modelValue: scope.row.CorreoRLSuplente,
                        "onUpdate:modelValue": ($event: any) => ((scope.row.CorreoRLSuplente) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionInfoRepresentanteSuplente.RLSuplente.$each.$response.$errors[scope.$index].CorreoRLSuplente, (error) => {
                        return (_openBlock(), _createBlock(_component_el_form_item, {
                          key: error,
                          class: "section-error-message"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(error.$message), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "¿Es PEP?",
                    "class-name": "header_color",
                    width: "130px;"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_select, {
                        modelValue: scope.row.EsPEPRLSuplente,
                        "onUpdate:modelValue": ($event: any) => ((scope.row.EsPEPRLSuplente) = $event),
                        placeholder: "Seleccionar",
                        onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.ValidaSiPEPRS()))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parametricas.generico, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.codigo,
                              label: item.valor,
                              value: item.valor
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "¿Tiene vínculos familiares con PEP?",
                    width: "170px;",
                    "class-name": "header_color"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_select, {
                        modelValue: scope.row.VinculosFamPEP_RLSuplente,
                        "onUpdate:modelValue": ($event: any) => ((scope.row.VinculosFamPEP_RLSuplente) = $event),
                        placeholder: "Seleccionar",
                        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.ValidaSiPEPRS()))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parametricas.generico, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.codigo,
                              label: item.valor,
                              value: item.valor
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, { width: "50" }, {
                    default: _withCtx((scope) => [
                      (scope.$index > 0)
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            circle: "",
                            class: "dinamic-form-button",
                            size: "small",
                            type: "success",
                            icon: "el-icon-minus",
                            onClick: ($event: any) => {_ctx.EliminarFilaRLSuplente(scope.$index);_ctx.ValidaSiPEPRS();}
                          }, null, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 2 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                circle: "",
                class: "dinamic-form-button",
                size: "small",
                type: "success",
                icon: "el-icon-plus",
                onClick: _ctx.AgregarFilaRLSuplente
              }, null, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}